/**
 * Явно указывает MapLibre, где лежит его воркер.
 *
 * maplibre-gl 6 стал ESM-only и при сборке бандлером сам URL воркера найти не может
 * (см. v5→v6 migration guide, «setWorkerUrl() is bundler-only»). Без этого вызова стиль
 * грузится, DOM-контролы (атрибуция) появляются, а тайлы никто не парсит — карта остаётся
 * пустым белым холстом. Вызывать до создания первой карты.
 */
import { setWorkerUrl } from 'maplibre-gl';
import maplibreWorkerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

let workerUrlRegistered = false;

export function registerMaplibreWorker(): void {
  if (workerUrlRegistered) {
    return;
  }
  workerUrlRegistered = true;
  setWorkerUrl(maplibreWorkerUrl);
}
